import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import TimerSelector from 'components/common/TimerSelector'

const Timer = ({ label, value, onChange, isRequired, exclude, error }) => (
  <div className={`smartchat-field timer ${error ? 'timer--error' : ''}`}>
    {label && (
      <div className='smartchat-field__header'>
        {label && <label>{label}</label>}
        <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
      </div>
    )}
    <div className='smartchat-field__body'>
      <TimerSelector
        isForced
        value={value}
        onChange={onChange}
        exclude={exclude}
      />
    </div>
  </div>
)

export default Timer
